import React from "react";
import { CSVLink } from "react-csv";
import IconButton from "@mui/material/IconButton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const CSVLinkWrapper = ({ data = [], headers = [], filename = "data.csv" }) => {
  const isDataAvailable = data.length > 0;

  const button = (
    <IconButton color="primary" disabled={!isDataAvailable}>
      <ExitToAppIcon />
    </IconButton>
  );

  return isDataAvailable ? (
    <CSVLink data={data} headers={headers} filename={filename}>
      {button}
    </CSVLink>
  ) : (
    button
  );
};

export default CSVLinkWrapper;
